import React from "react";
import {
  Card,
  CardContent,
} from "@/shared/ui/card"
import { Label } from "@/shared/ui/label"
import { Input } from "@/shared/ui/input"
import { Link } from "react-router-dom";
import { ProfileWrapper } from '@/shared/components/CardWrapper'
import { useSelector } from "react-redux";
import { selectUserData } from "@/api/rtk/userSelectors"
import LanguageSwitcher from '@/shared/components/LanguageSwitcher';
import { useTranslation } from "react-i18next";

const General = () => {
  const { t } = useTranslation();
  const email = localStorage.getItem('email');
  const user = useSelector(selectUserData);

  return (
    <ProfileWrapper
      title={t("profile.tabs.general")}
      description={t("profile.general.description")}
      hasButton={false}
    >
      <CardContent className="px-0 relative">
        <Card className={`rounded-2xl ${user?.is_admin ? 'h-[255x]' : 'h-[180px]'}`}>
          <CardContent className="p-5 h-full">
            <form action="" className="flex flex-col flex-wrap gap-4">
              <div className="flex flex-col gap-[3px]">
                <div className="flex justify-between items-center">
                  <Label className="font-SuisseIntlLight font-semibold">
                    {t("common.email")}
                  </Label>
                  <Link to="mailto:hey@mpassist.ai" className="font-SuisseIntlLight font-semibold text-[14px] text-[#71717A] underline">
                    {t("profile.general.changeEmail")}
                  </Link>
                </div>
                <Input
                  className="font-semibold placeholder:font-SuisseIntlLight placeholder:font-semibold"
                  placeholder="george@mail.com"
                  value={email}
                  disabled
                  type="email"
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label className="font-semibold font-SuisseIntlLight">
                  {t("profile.general.language")}
                </Label>
                <LanguageSwitcher />
              </div>
            </form>
          </CardContent>
        </Card>
      </CardContent>
    </ProfileWrapper>
  );
};

export default General;
